import { CommonModule } from '@angular/common';
import { Component, computed, input, output, TemplateRef, viewChild } from '@angular/core';

import { IPaginationResponseResolver, ISoftDeletablePaginationParameters } from '../../../data-access';
import { IActionConfig, IActionExecutedEvent, ITableConfig } from '../../../ui';
import { ISoftDeletableTranslatableAuditableLookup } from '../../../primitives';
import { SoftDeletableAuditableLookupsComponent } from '../soft-deletable-auditable-lookups/soft-deletable-auditable-lookups.component';

@Component({
  selector: 'app-soft-deletable-auditable-translatable-lookups',
  standalone: true,
  providers: [],
  imports: [CommonModule, SoftDeletableAuditableLookupsComponent],
  templateUrl: './soft-deletable-auditable-translatable-lookups.component.html',
  styleUrls: ['./soft-deletable-auditable-translatable-lookups.component.scss']
})
export class SoftDeletableAuditableTranslatableLookupsComponent<
  TEntity extends ISoftDeletableTranslatableAuditableLookup,
  TPaginationParameters extends ISoftDeletablePaginationParameters
> {
  tableRowTemplate = viewChild.required<TemplateRef<{ $implicit: TEntity }>>('tableRowTemplate');
  paginationResponseResolver = input.required<IPaginationResponseResolver<TEntity, TPaginationParameters>>();
  defaultPaginationParameters = input.required<TPaginationParameters>();
  supportedActions = input.required<IActionConfig<TEntity>[]>();
  tableConfig = input<ITableConfig>();

  actionExecuted = output<IActionExecutedEvent<TEntity>>();

  finalTableConfig = computed(() => ({
    fields: [{ name: 'arabicName', displayName: 'GENERAL.ARABIC_NAME' }, ...(this.tableConfig()?.fields ?? [])],
    template: this.tableRowTemplate()
  }));

  onActionExecuted(event: unknown) {
    this.actionExecuted.emit(event as IActionExecutedEvent<TEntity>);
  }
}
